import { IConfig } from '@cian/config/shared';

import { IGetNewbuildingPromoPinsForMapResponseSchema } from 'shared/common/repositories/search-offers-index/entities/get_newbuilding_promo_pins_for_map/GetNewbuildingPromoPinsForMapResponseSchema';
import { IErrorResponseSchema } from 'shared/common/repositories/search-offers-index/entities/schemas/ErrorResponseSchema';
import {
  IGetNewbuildingPromoPinsForMapOptions,
  TGetNewbuildingPromoPinsForMapRequest,
  TGetNewbuildingPromoPinsForMapModel,
  TGetNewbuildingPromoPinsForMapResponse,
  createGetNewbuildingPromoPinsForMapModel as createGetNewbuildingPromoPinsForMapModelOriginal,
} from 'shared/common/repositories/search-offers-index/v1/get-newbuilding-promo-pins-for-map';
import { IApplicationContext } from 'shared/map-search/types/applicationContext';
import { withJobName } from 'shared/map-search/utils/withJobName';

import { mapGetNewbuildingPromoPinsForMapResponse, mapGetNewbuildingPromoPinsForMapResponseError } from '../mappers';

export async function fetchGetNewbuildingPromoPinsForMap(
  context: IApplicationContext,
  options: Omit<
    IGetNewbuildingPromoPinsForMapOptions<IGetNewbuildingPromoPinsForMapResponseSchema, IErrorResponseSchema>,
    'httpApi' | 'mappers'
  >,
) {
  const { httpApi } = context;

  const result = await httpApi.fetch(
    createGetNewbuildingPromoPinsForMapModel(context.config, options.parameters),
    options.config,
  );

  if (result.statusCode === 200) {
    return mapGetNewbuildingPromoPinsForMapResponse(result.response as IGetNewbuildingPromoPinsForMapResponseSchema);
  }

  if (result.statusCode === 400) {
    return mapGetNewbuildingPromoPinsForMapResponseError(result.response as IErrorResponseSchema);
  }

  return {
    statusCode: result.statusCode,
    response: result.response,
    headers: result.headers,
  } as TGetNewbuildingPromoPinsForMapResponse;
}

function createGetNewbuildingPromoPinsForMapModel(
  config: IConfig,
  parameters: TGetNewbuildingPromoPinsForMapRequest,
): TGetNewbuildingPromoPinsForMapModel {
  const requestConfig = createGetNewbuildingPromoPinsForMapModelOriginal(parameters);

  return withJobName(config, requestConfig);
}
